 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vendors." + {"0":"815d161d2e3e21d6a24b","1":"cdce96c39a36d54b8171","2":"dd1aaec6511715182b50","3":"8fc04a73a734bd2818cb","4":"fa43e796f86ba29c909c","5":"603705054bc0e20914cb","6":"8ceced912573d96e173a","7":"8569b3c64067bd2a719d","vendors~Comment~ShareComment":"2662ae54dcbac089a132","vendors~Comment~LoginDialog":"a141b0658733fee71982","vendors~Comment~Survey":"e048aae209cb99d0e775","Comment":"2f7194768bbfba5c2fa2","vendors~Player":"5b98ff984b2bfa0f1011","Player":"25346e0e876a6a8bc346","AccountOpening":"2effab80d8b75c77ab0c","BackTopBottom":"36423da13f2192e6d3c0","Caption":"6c50a7974ff8402762e2","Copyright":"a2846939a8c34a80660c","DataBox":"9413bd2e92b590055ac8","Img":"ceb3ef7599d71828a7db","LivePlayer":"7de1b0f87bc0d9d01d69","MoreTabs":"29139afe48b1448e4613","Nav":"dfc37be24a36e9008c82","NormalCaption":"eea2ec761dbd66511002","Offline":"fb0da445e487c992cbda","QQShare":"049a54985c5a0a206793","Stick":"e69c349525c2e2bbd03a","Tip":"8494f70a4f7e40fca141","ViewMoreLink":"e3c461785ce4c41b5bfc","WxLaunchApp":"b2d92311fd8173b2cfe4","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"51e8e72153340c50a635","Atlas":"495e1828f8620022c620","FiveNavPic":"96a24035aa44edb5e159","FourNavPic":"0df59b6d9799e806dc7b","vendors~MdBanner":"e109556e741711a8add7","vendors~BigImage~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~CallupVideoAppHead~HomeFo~464104dc":"22b045198678fccbcfb4","CallupVideoAppHead":"6cab20c088bdee34d699","HomeFooter":"4164647630deb462f557","Hongbao":"bde664dbed5bce90a948","TwoImage":"786415c5d58285a87eb5","ThreeNavPic":"cc9817650ae0c73f40b0","vendors~BigImage~NewsStream~NoImage~OneImage~ThreeImage":"7a746693d4893c072595","BigImage":"cbd382250191112fb2c2","NoImage":"f767868bd67946a23566","OneImage":"bf9f801a8331261c547a","ThreeImage":"e237e2d0c0512d60a4cc","vendors~NewsStream":"4783d40e5b2081523a36","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"3a25b6b1b042bd421f97","SingleTitle":"1e426424ffa0fc3e3153","TwoImg":"303f7bb5258b19f70902","InformationFlow":"47c7cf85ba466d8b2b12","vendors~BigImg":"03889e97546070655fce","BigImg":"e574210780d6cf887db5","vendors~BigTopic~TitleImg":"c84d4f171ec4f7e0a3fc","BigTopic":"bf8849cdd77807b5b80f","TitleImg":"2b3fd520084877bb8808","vendors~SlideImg":"d92efe6ce869e8331569","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"6873a491507ea47b3235","NormalSlides":"ac525cf20f89932e46a8","ShareSlides":"d2338d866022c7cef684","vendors~BottomSlides~UpgradeBottomSlides":"9c5f22577d0e5c749737","UpgradeBottomSlides":"5bb6efb3dd90724afbf0","vendors~IndexSlides":"d333a958d64fd74464fa","vendors~BrowserGuideLayer":"9d54fb18b0258e7f9884","vendors~CallupHead":"b035309eebf0ae4c9290","vendors~ShareComment":"7b762fbb570230f19240","vendors~Survey":"c414f0e8e73b63542af1","vendors~NormalTabs":"abde8807893080166caf","vendors~WXGuideLayer":"9ff5494729d832f23623","LoginDialog":"5653fa7fabe1ce277e01","vendors~MarkTabs":"47bb4a972ee2b69f2f1b","vendors~PageBottomBrand":"1fae38d78cf1825da00c","vendors~SimpleGuideLayer":"3f494103234a3f8dc35d","vendors~SlidesTabs":"54ecb81a4f603e8e184a","vendors~pics":"b9b7a1a9082aa8c1b011","pics":"a16a6b2516cefa72fb1b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/content/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
